export { default as UserMenuProfilePaymentsLink } from './UserMenuProfilePaymentsLink';
